import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

interface HotRecommendProps {
  activeCategory: string;
}

export default function HotRecommend({ activeCategory }: HotRecommendProps) {
  const filtered = activeCategory === 'all'
    ? comics
    : comics.filter((c) => c.category === activeCategory);

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">精选无删减完整版韩国漫画，下拉观看更畅快</p>
          </div>
          <div className="hidden md:flex items-center gap-2">
            <button className="w-9 h-9 flex items-center justify-center rounded-full border border-background-300/60 text-foreground-500 hover:bg-background-100 hover:text-foreground-900 transition-colors cursor-pointer">
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button className="w-9 h-9 flex items-center justify-center rounded-full border border-background-300/60 text-foreground-500 hover:bg-background-100 hover:text-foreground-900 transition-colors cursor-pointer">
              <i className="ri-arrow-right-s-line"></i>
            </button>
          </div>
        </div>

        {filtered.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
            {filtered.map((comic) => (
              <ComicCard key={comic.id} {...comic} />
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
              <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
            </div>
            <p className="text-foreground-500">该分类暂无漫画，请浏览其他分类</p>
          </div>
        )}
      </div>
    </section>
  );
}